import script from "./SubscriptionConfirmPlanModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubscriptionConfirmPlanModal.vue?vue&type=script&lang=ts&setup=true"

import "./SubscriptionConfirmPlanModal.vue?vue&type=style&index=0&id=22985140&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22985140"]])

export default __exports__